/**
 * @flow
 * @relayHash b024b23da3b0cc4bdfecc798169edbc3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Likes_viewer$ref = any;
export type LikesRefetchQueryVariables = {|
  createdAfter: string,
  eventsLimit: number,
  fetchNewEvents: boolean,
  fetchNotifications: boolean,
  notificationItemsLimit: number,
  userId: string,
|};
export type LikesRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: Likes_viewer$ref
  |}
|};
export type LikesRefetchQuery = {|
  variables: LikesRefetchQueryVariables,
  response: LikesRefetchQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "createdAfter",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "eventsLimit",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchNewEvents",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchNotifications",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "notificationItemsLimit",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String"
  }
],
v3 = {
  "kind": "Variable",
  "name": "createdAfter",
  "variableName": "createdAfter",
  "type": "String"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LikesRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Likes_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "createdAfter",
                "variableName": "createdAfter",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "eventsLimit",
                "variableName": "eventsLimit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "fetchNewEvents",
                "variableName": "fetchNewEvents",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "fetchNotifications",
                "variableName": "fetchNotifications",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "notificationItemsLimit",
                "variableName": "notificationItemsLimit",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "LikesRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchNotifications",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "favoriteNotificationsTiles",
                "name": "favoriteNotifications",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "FavoriteNotifications",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "tiles",
                    "name": "notificationsList",
                    "storageKey": null,
                    "args": [
                      (v3/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "notificationItemsLimit",
                        "variableName": "notificationItemsLimit",
                        "type": "Int"
                      },
                      {
                        "kind": "Variable",
                        "name": "notificationsLimit",
                        "variableName": "eventsLimit",
                        "type": "Int"
                      }
                    ],
                    "concreteType": "FavoriteNotification",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "followingType",
                        "args": null,
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "eventType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastViewedDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "type",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "page",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalResults",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pdpURL",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstPhotoWebPath",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "thumb",
                                "type": "ImageVersionTypeName!"
                              }
                            ],
                            "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                          },
                          (v1/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchNewEvents",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "favoriteNotifications",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "FavoriteNotifications",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNewEvents",
                    "args": [
                      (v3/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "eventsLimit",
                        "variableName": "eventsLimit",
                        "type": "Int"
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "LikesRefetchQuery",
    "id": "dibs-buyer-layout/209.2.8-2019-03-25T20:56:18.750Z/LikesRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ab2f3c4d7c41daccff0f4fa979704e09';
module.exports = node;
